import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useClientStore = defineStore('client', () => {
    const email = ref(null);
    const getEmail = computed(() => email.value);

    const externalReference = ref(null);
    const getExternalReference = computed(() => externalReference.value);

    function $reset() {
        email.value = null;
        externalReference.value = null;
    }

    return { email, getEmail, externalReference, getExternalReference, $reset }
}, { persist: true })
